import { HttpClient } from '../httpClient';
import ProofingRule from '../models/proofingRule';
import ProofingRuleBuilderConfig from '../models/proofingRuleBuilderConfig';
import ProofingRuleScope from '../models/proofingRuleScope';
import TimesheetProofingDebugResultModel from '../models/timesheetProofingDebugResult';
import { BaseResponse, DataResponse } from '../responses/baseResponse';

const httpClient = new HttpClient();

export const getProofingRules = async () => {
  return httpClient.get<DataResponse<ProofingRule[]>>({
    url: '/v1/proofingrules',
    requiresToken: true,
  });
};

export const getProofingRuleById = async (id:number) => {
  return httpClient.get<DataResponse<ProofingRule>>({
    url: `/v1/proofingrules/${id}`,
    requiresToken: true
  });
};

export const addEditProofingRule = async (rule:ProofingRule) => {
  return httpClient.post<DataResponse<number>>({
    url: '/v1/proofingrules/AddEditRule',
    payload: rule,
    requiresToken: true,
  });
}

export const deleteProofingRule = async (proofingRuleId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/proofingrules/${proofingRuleId}`,
    requiresToken: true,
  });
};

export const getProofingBuilderConfig = async () => {
  return httpClient.get<DataResponse<ProofingRuleBuilderConfig>>({
    url: `/v1/proofingrules/configfields`,
    requiresToken: true
  });
};

export const getDebugProofingRule = async (timesheetId:number, ruleId:number) => {
  return httpClient.get<DataResponse<TimesheetProofingDebugResultModel>>({
    url: `/v1/proofingrules/${ruleId}/debug/${timesheetId}`,
    requiresToken: true
  })
}

export const getProofingScopes = async () => {
  return httpClient.get<DataResponse<ProofingRuleScope[]>>({
    url: `v1/proofingrules/scopes`,
    requiresToken: true
  });
}